import type { IncomeReportingFormValues, IncomeSourcePayload } from "./types";

export const incomeSourceToFormValues = ({
  income_type,
  mortgage_rent,
  uuid: _,
  ...rest
}: API.IncomeSource): IncomeReportingFormValues => ({
  incomeType: income_type,
  mortgageRent: mortgage_rent !== null ? mortgage_rent : undefined,
  ...rest,
});

export const prepareIncomeSourcePayload = ({
  incomeType,
  mortgageRent,
  ...rest
}: IncomeReportingFormValues) => {
  const data: IncomeSourcePayload = {
    income_type: incomeType,
    ...rest,
  };

  if (mortgageRent !== undefined && mortgageRent !== null) {
    data.mortgage_rent = mortgageRent;
  }

  return data;
};
